import React, { useEffect, useState } from "react";
import { IBaseFieldProperty, IPropertyEditorProps, IUIFieldProps, applyAtPath, registerUIField } from "../../common";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, RemoveButton } from "../../ui-props/common";
import { generateFullUUID, hasValue, parseValue } from "../../../../util";
import './TabLayout.scss';
import { FieldContainer } from "../../FieldContainer";
import { Button, Checkbox, Input, Label, Select } from "uxp/components";
import jp from 'jsonpath'

interface ITabLayoutField extends IBaseFieldProperty {
    tabs?: ITab[],
    tabBackgroundColor?: string,
    tabTextColor?: string,
    tabSelectedBackgroundColor?: string,
    tabSelectedTextColor?: string,
    tabContentBackgroundColor?: string
}

interface ITab {
    id: string,
    title: string
}

export function generateTabs(props: ITabLayoutField) {
    const { tabs } = props
    if (!tabs || tabs.length == 0) return Array(2).fill(0).map((a, i) => ({ id: generateFullUUID(), title: `Tab ${i + 1}` } as ITab))
    return tabs
}

const Field: React.FunctionComponent<IUIFieldProps<ITabLayoutField>> = (props) => {

    const fiedProps = props.fieldProps
    const [tabs, setTabs] = useState<ITab[]>([])
    const [selectedTab, setSelectedTab] = useState<ITab>(null)

    useEffect(() => {
        setTabs(fiedProps.tabs || [])
    }, [fiedProps.tabs])


    useEffect(() => {
        if (!selectedTab) {
            setSelectedTab(tabs?.[0])
        }
    }, [tabs, selectedTab])

    useEffect(() => {
        console.log('props______________ssss', props)
    }, [props])

    const tabHeaderStyles: React.CSSProperties = { backgroundColor: 'white' }

    const tabStyles: React.CSSProperties = { backgroundColor: 'white', color: '#424242' }
    if (hasValue(fiedProps.tabBackgroundColor)) {
        tabStyles.backgroundColor = parseValue(fiedProps.tabBackgroundColor, props.contextData)
        tabHeaderStyles.backgroundColor = parseValue(fiedProps.tabBackgroundColor, props.contextData)
    }
    if (hasValue(fiedProps.tabTextColor)) tabStyles.color = parseValue(fiedProps.tabTextColor, props.contextData)

    const selectedTabStyles: React.CSSProperties = { backgroundColor: '#424242', color: 'white' }
    if (hasValue(fiedProps.tabSelectedBackgroundColor)) selectedTabStyles.backgroundColor = parseValue(fiedProps.tabSelectedBackgroundColor, props.contextData)

    if (hasValue(fiedProps.tabSelectedTextColor)) selectedTabStyles.color = parseValue(fiedProps.tabSelectedTextColor, props.contextData)


    const tabContnetStyles: React.CSSProperties = {}
    if (hasValue(fiedProps.tabContentBackgroundColor)) tabContnetStyles.backgroundColor = parseValue(fiedProps.tabContentBackgroundColor, props.contextData)

    return <div className='wd-tab-layout-container'>
        <div className="wd-tab-layout-header" style={tabHeaderStyles} >
            {tabs.map((t, i) => {
                return <div className='wd-tab-layout-tab' key={i}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()

                        setSelectedTab(t)
                    }}
                    style={t.id == selectedTab?.id ? selectedTabStyles : tabStyles}
                >
                    {t.title}
                </div>
            })}
        </div>

        <div className='wd-tab-layout-tab-content' style={tabContnetStyles}>

            {!!selectedTab &&
                <div className="wd-tab-layout-fields-container">
                    <FieldContainer
                        designer={props.designer}
                        uxpContext={props.uxpContext}
                        contextData={props.contextData}
                        onChangeData={props.onChangeContextData}
                        uiProps={props.uiProps}
                        dataKey={props.dataKey}
                        droppableContainerId={selectedTab?.id}
                        droppableParentContainerId={props.droppableParentContainerId}
                        propPath={props.propPath}
                        disabled={props.disableDrop || false}
                        onChangeFields={props.onChangeFields}
                    />
                </div>
            }
        </div>
    </div>

}

export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITabLayoutField>> = (props) => {

    let _props = props.uiProps

    useEffect(() => {
        console.log('_________props_____', _props)
    }, [_props])

    function updateTab(id: string, title: string) {
        let _cols = (_props.tabs || [])
        const updated = _cols.map(c => {
            if (c.id == id) c.title = title
            return c
        })
        jp.apply(_props, `$.tabs`, () => updated)
        props.onChange(_props)
    }

    function addTab() {
        let _cols = (_props.tabs || [])
        _cols.push({ id: generateFullUUID(), title: `tab ${_cols.length + 1}` })

        jp.apply(_props, `$.tabs`, () => _cols)
        props.onChange(_props)
    }

    function removeTab(id: string) {
        let _cols = (_props.tabs || [])
        let updated = _cols.filter(c => c.id !== id)

        jp.apply(_props, `$.tabs`, () => _cols)
        props.onChange(_props)
    }

    return <PropertyContainer>
        <PropertyContainerTitle> Tab Layout </PropertyContainerTitle>

        <PropertyGroup>

            <Property>
                <PropertyTitle>Tabs </PropertyTitle>

                <div className="tab-layout-tab-list">
                    {
                        _props.tabs?.map((t, i) => {
                            return <div className="tab-layout-column">
                                <Label>
                                    Tab {i + 1}
                                </Label>
                                <Input
                                    value={t.title || ''}
                                    onChange={s => {
                                        updateTab(t.id, s)
                                    }}
                                    placeholder="Auto"
                                />
                                {_props.tabs?.length > 2 &&
                                    <RemoveButton onClick={() => removeTab(t.id)} />
                                }
                            </div>
                        })
                    }

                    <Button
                        className="new-option"
                        title="Add Column"
                        icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                        iconPosition="right"
                        onClick={() => addTab()}
                    />
                </div>

            </Property>

            <Property>
                <PropertyTitle>Tab background color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={_props.tabBackgroundColor}
                    onChange={s => {
                        _props.tabBackgroundColor = s
                        props.onChange(_props)
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Tab text color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={_props.tabTextColor}
                    onChange={s => {
                        _props.tabTextColor = s
                        props.onChange(_props)
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Selected tab background color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={_props.tabSelectedBackgroundColor}
                    onChange={s => {
                        _props.tabSelectedBackgroundColor = s
                        props.onChange(_props)
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Selected tab text color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={_props.tabSelectedTextColor}
                    onChange={s => {
                        _props.tabSelectedTextColor = s
                        props.onChange(_props)
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Tab content background color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData}
                    color={_props.tabContentBackgroundColor}
                    onChange={s => {
                        _props.tabContentBackgroundColor = s
                        props.onChange(_props)
                    }}
                />
            </Property>

        </PropertyGroup>
    </PropertyContainer>
}



registerUIField({
    id: 'tab-layout',
    category: 'layout',
    description: 'Tab Layout',
    field: Field,
    propertyEditor: PropertyEditor,
    defaultProps: {
    },
    onDropField: (f) => {
        if (!f.props) f.props = {}
        f.props.tabs = generateTabs({})
        return f
    }
});